import script from "./LockStatusComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./LockStatusComponent.vue?vue&type=script&setup=true&lang=js"

import "./LockStatusComponent.vue?vue&type=style&index=0&id=215c4a4a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-215c4a4a"]])

export default __exports__